export default __webpack_public_path__ + "static/Mirage_Hotel_and_Casino-a1d661227c31f471e72789443831cdc8.svg";